import { createBrowserRouter } from 'react-router-dom';
import { AppShell } from './AppShell';
import { AuditPage } from '../pages/AuditPage';
import { CustomerDetailPage } from '../pages/CustomerDetailPage';
import { SiteDetailPage } from '../pages/SiteDetailPage';
import { CustomersPage } from '../pages/CustomersPage';
import { DashboardPage } from '../pages/DashboardPage';
import { HelpPage } from '../pages/HelpPage';
import { InventoryPage } from '../pages/InventoryPage';
import { ItemDetailPage } from '../pages/ItemDetailPage';
import { NotFoundPage } from '../pages/NotFoundPage';
import { NotificationsPage } from '../pages/NotificationsPage';
import { PartsPage } from '../pages/PartsPage';
import { FieldWorkBoardPage } from '../pages/FieldWorkBoardPage';
import { FieldWorkPage } from '../pages/FieldWorkPage';
import { FieldWorkReportsPage } from '../pages/FieldWorkReportsPage';
import { FieldWorkRequestDetailPage } from '../pages/FieldWorkRequestDetailPage';
import { FieldWorkSettingsPage } from '../pages/FieldWorkSettingsPage';
import { FulfillmentOrderPage } from '../pages/FulfillmentOrderPage';
import { PackingListPage } from '../pages/PackingListPage';
import { FulfillmentPage } from '../pages/FulfillmentPage';
import { FulfillmentTemplatesPage } from '../pages/FulfillmentTemplatesPage';
import { GoodsIntakePage } from '../pages/GoodsIntakePage';
import { GoodsReceiptPage } from '../pages/GoodsReceiptPage';
import { ShipmentDetailPage } from '../pages/ShipmentDetailPage';
import { ShipmentsPage } from '../pages/ShipmentsPage';
import { ShippedItemsPage } from '../pages/ShippedItemsPage';
import { SitesPage } from '../pages/SitesPage';
import { StockItemPage } from '../pages/StockItemPage';
import { StockPage } from '../pages/StockPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    errorElement: <NotFoundPage />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'inventory', element: <InventoryPage /> },
      { path: 'inventory/:itemId', element: <ItemDetailPage /> },
      { path: 'parts', element: <PartsPage /> },
      { path: 'sites', element: <SitesPage /> },
      // §9a/§9b proposal (tidaltech/koi#7882), live-backed by leatherback's
      // ShipmentsService — see api/shipments-api.ts.
      { path: 'shipments', element: <ShipmentsPage /> },
      { path: 'shipments/shipped-items', element: <ShippedItemsPage /> },
      { path: 'shipments/:shipmentId', element: <ShipmentDetailPage /> },
      // The Field Ops work queue -- see leatherback's
      // FieldWorkRequestsService and domain/fieldWorkRequest.ts (issue
      // #7957). Evolved in place from the earlier shipment-requests page.
      { path: 'field-work', element: <FieldWorkPage /> },
      { path: 'field-work/board', element: <FieldWorkBoardPage /> },
      { path: 'field-work/reports', element: <FieldWorkReportsPage /> },
      { path: 'field-work/settings', element: <FieldWorkSettingsPage /> },
      { path: 'field-work/:requestId', element: <FieldWorkRequestDetailPage /> },
      // Pick & pack, backed by leatherback's FulfillmentService
      // (tidaltech/koi#8083, #8084).
      { path: 'fulfillment', element: <FulfillmentPage /> },
      { path: 'fulfillment/templates', element: <FulfillmentTemplatesPage /> },
      { path: 'fulfillment/:orderId', element: <FulfillmentOrderPage /> },
      { path: 'fulfillment/:orderId/packing-list', element: <PackingListPage /> },
      // Quantity-controlled stock (tidaltech/koi#8096).
      { path: 'stock', element: <StockPage /> },
      { path: 'stock/items/:stockItemId', element: <StockItemPage /> },
      // Goods Intake (tidaltech/koi#8101).
      { path: 'goods-intake', element: <GoodsIntakePage /> },
      { path: 'goods-intake/:receiptId', element: <GoodsReceiptPage /> },
      { path: 'customers', element: <CustomersPage /> },
      { path: 'customers/:customerId', element: <CustomerDetailPage /> },
      { path: 'customers/:customerId/sites/:siteId', element: <SiteDetailPage /> },
      { path: 'notifications', element: <NotificationsPage /> },
      { path: 'audit', element: <AuditPage /> },
      { path: 'help', element: <HelpPage /> },
      { path: 'help/developer', element: <HelpPage guide="developer" /> },
    ],
  },
]);
